import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalHeaderModule } from './modal-header.module';
import { ModalFooterModule } from './modal-footer.module';
import { ModalContentModule } from './modal-content.module';
import { DividerModule } from '../divider/divider.module';
import * as Hammer from 'hammerjs';

import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { IconModule } from '../icon/icon.module';

export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

@NgModule({
  declarations: [ModalComponent],
  imports: [
    HammerModule,
    CommonModule,
    BrowserAnimationsModule,
    ModalHeaderModule,
    ModalFooterModule,
    ModalContentModule,
    DividerModule,
    IconModule,
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
  ],
  exports: [ModalComponent],
})
export class ModalModule {}
